const paginationLinks = document.querySelectorAll(".pagenav li a");
const allowedFilters = {
  Category: [],
  Type: [],
  Diet: [],
};
const filters = {
  Category: "filter.p.m.custom.filter_category",
  Type: "filter.p.m.custom.filter_type",
  Diet: "filter.p.m.custom.filter_diet",
};

function parseSearchQuery(targetPage) {
  const pathname = window.location.pathname;
  const search = window.location.search;
  const urlParams = new URLSearchParams(search);
  let newUrl = pathname + "?";

  for (const param of urlParams) {
    const [key, value] = param;

    if (key === filters.Category) {
      allowedFilters.Category.push(value);
    }
    if (key === filters.Type) {
      allowedFilters.Type.push(value);
    }
    if (key === filters.Diet) {
      allowedFilters.Diet.push(value);
    }
  }

  const categoryFilterString = allowedFilters.Category.join(",");
  const typeFilterString = allowedFilters.Type.join(",");
  const dietFilterString = allowedFilters.Diet.join(",");

  if (categoryFilterString.length > 0) {
    newUrl += `${filters.Category}=${categoryFilterString}`;
  }
  if (typeFilterString.length > 0) {
    const isFirstParam = !newUrl.includes(filters.Category);

    newUrl += `${isFirstParam ? "" : "&"}${filters.Type}=${typeFilterString}`;
  }
  if (dietFilterString.length > 0) {
    const isFirstParam =
      !newUrl.includes(filters.Category) && !newUrl.includes(filters.Type);

    newUrl += `${isFirstParam ? "" : "&"}${filters.Diet}=${dietFilterString}`;
  }

  const isFirstParam =
      !newUrl.includes(filters.Category) ||
      !newUrl.includes(filters.Type) ||
      !newUrl.includes(filters.Diet);

    newUrl += `${!isFirstParam ? "" : "&"}page=${targetPage}`;

  return newUrl;
}

paginationLinks.forEach((link) => {
  const targetPage = link.getAttribute("data-page");

  const newTarget = parseSearchQuery(targetPage);

  link.setAttribute("href", newTarget);
});
